import { tv } from "../../../variants/tv.js";
const tBodyVariants = tv({
    base: 'relative',
    variants: {},
    defaultVariants: {}
});
export { tBodyVariants };
